// 휴대폰번호
export const mobileRegex = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;

// 이메일
export const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

// 생년월일
export const birthRegex = /^[0-9]{6}$/;

// 주민등록번호
export const juminRegex = /^[0-9]{13}$/;
